import React from "react";
import * as Bananas from "bananas-commerce-admin";

import { TableBody } from "@mui/material";

import { ObituaryMediaResponse } from "../../types";

import OrderRow from "./OrderRow";

export type OrdersListColumns = Record<keyof ObituaryMediaResponse, string>;

export interface OrdersListProps {
  data: ObituaryMediaResponse[];
  showPublicationAbbreviation?: boolean;
  showDeceased?: boolean;
}

const OrdersList: React.FC<OrdersListProps> = ({
  data,
  showPublicationAbbreviation = true,
  showDeceased = true,
}) => {
  return (
    <Bananas.TableCard>
      <Bananas.Table count={data.length}>
        <Bananas.TableHead>
          <Bananas.TableHeading>Status</Bananas.TableHeading>
          <Bananas.TableHeading>Ordernummer</Bananas.TableHeading>
          {showPublicationAbbreviation && (
            <Bananas.TableHeading>Tidning</Bananas.TableHeading>
          )}
          <Bananas.TableHeading>Beställare</Bananas.TableHeading>
          <Bananas.TableHeading>Annonstyp</Bananas.TableHeading>
          {showDeceased && <Bananas.TableHeading>Avliden</Bananas.TableHeading>}
          <Bananas.TableHeading>Införandedatum</Bananas.TableHeading>
          {/* TODO Cost column */}
        </Bananas.TableHead>
        <TableBody>
          {data.map((obituary) => (
            <OrderRow
              key={obituary.id}
              data={obituary}
              showDeceased={showDeceased}
              showPublicationAbbreviation={showPublicationAbbreviation}
            />
          ))}
        </TableBody>
      </Bananas.Table>
    </Bananas.TableCard>
  );
};

export default OrdersList;
